import { useT } from '../../i18n/LanguageContext';
import React, { useEffect, useRef, useState } from 'react';
import distributorService from '../../services/distributorService';
import useShippingRequest from '../../hooks/useShippingRequest';
import CashBank from './CashBank';
import { validBalance } from './cashContract';
export default function CashBankBoundary({
  distributorId,
  admin = false,
  onModeChange,
  readOnly = false,
}) {
  const t = useT();
  const [state, setState] = useState(null);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  const modeCallback = useRef(onModeChange);
  modeCallback.current = onModeChange;
  useEffect(() => {
    modeCallback.current?.(error || !state ? null : 'cash');
  }, [state, error]);
  const { begin, version } = useShippingRequest(`cash-mode:${distributorId || 'own'}`);
  useEffect(() => {
    const request = begin();
    setState(null);
    setError(false);
    const pending = distributorService.cashBalance(distributorId, {
      signal: request.signal,
    });
    Promise.resolve(pending)
      .then((response) => {
        if (!request.isCurrent()) return;
        const data = response?.data?.data;
        if (!validBalance(data)) throw new Error('Invalid cash bank');
        setState(data);
      })
      .catch(() => {
        if (!request.isCurrent()) return;
        setError(true);
      });
  }, [begin, version, distributorId, retry]);
  if (error)
    return (
      <div className="me-cash" role="alert">
        {t('Bank mode could not be verified. No balance is shown.')}
        <button type="button" onClick={() => setRetry((value) => value + 1)}>
          {t('Retry bank')}
        </button>
      </div>
    );
  if (!state) return <p role="status">{t('Loading bank\u2026')}</p>;
  return (
    <div className="me-cash">
      {admin && (
        <p className="me-cash-note">
          {t(
            'Virtual Tissue Bank Balance is shown in USD. Historical unit records remain unchanged.'
          )}
        </p>
      )}
      <CashBank
        key={`${distributorId || 'own'}:${version}:${retry}`}
        distributorId={distributorId}
        balance={state}
        readOnly={readOnly || admin}
        onRefresh={() => setRetry((value) => value + 1)}
      />
    </div>
  );
}
